import { createFileRoute } from "@tanstack/react-router"
import CustomHead from "~/components/SEOHead/CustomHead"
import VoiceList from "~/components/Voices/VoiceList"
import AppLayout from "~/layouts/AppLayout"
import { api } from "~/utils/api"
import { getInternalPageTitle, InternalSection } from "~/utils/seo"

function VoicesPage() {
  const { data: voiceList } = api.voices.getPrivateVoices.useQuery()

  return (
    <AppLayout head={<CustomHead title={getInternalPageTitle(InternalSection.VOICES)} />}>
      <VoiceList voiceList={voiceList ?? []} />
    </AppLayout>
  )
}

export const Route = createFileRoute("/voices")({
  component: VoicesPage,
})
